<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-3">Select Birth Record Product</h1>
            <b-row>
                <b-col>
                    <router-link to="/product-select">
                        <b-button variant="secondary">
                            <b-icon-box-arrow-in-left/>Return to Category Selection
                        </b-button>
                    </router-link>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col>
                    <router-link :to="{name: 'birth-certified'}">
                        <b-card
                                class="order-card"
                                border-variant="primary"
                                header="Certified Birth Certificate"
                                header-class="text-left"
                                header-bg-variant="primary"
                                header-text-variant="white"
                                align="left"
                        >
                            <b-card-text class="no-decoration">
                                Certified record of a birth issued on security paper. Available for births from 1900 to the present.
                            </b-card-text>
                            <b-card-text class="no-decoration">
                              <b>Price:</b> $26 (Additional Copies $19)
                            </b-card-text>
                        </b-card>
                    </router-link>
                </b-col>
              </b-row>
<!--              <b-row>-->
<!--                <b-col>-->
<!--                    <router-link :to="{name: 'birth-noncertified'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Informational Noncertified Birth Record - No Health Information"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text class="no-decoration">-->
<!--                                Noncertified (informational only) birth record issued from the electronic record on plain paper. Available for births from-->
<!--                                2001 to the present.-->
<!--                            </b-card-text>-->
<!--                            <b-card-text class="no-decoration">-->
<!--                              <b>Price:</b> $13 (Additional Copies $6)-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  <router-link :to="{name: 'birth-noncertified-health'}">-->
<!--                    <b-card-->
<!--                        class="order-card"-->
<!--                        border-variant="primary"-->
<!--                        header="Informational Noncertified Birth Record with Health Information"-->
<!--                        header-class="text-left"-->
<!--                        header-bg-variant="primary"-->
<!--                        header-text-variant="white"-->
<!--                        align="left"-->
<!--                    >-->
<!--                      <b-card-text class="no-decoration">-->
<!--                        Noncertified (informational only) birth record issued from the electronic record on plain paper.-->
<!--                        Available only to person who gave birth, for births from 2001 to the present.-->
<!--                      </b-card-text>-->
<!--                      <b-card-text class="no-decoration">-->
<!--                        <b>Price:</b> $13 (Additional Copies $6)-->
<!--                      </b-card-text>-->
<!--                    </b-card>-->
<!--                  </router-link>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                    <router-link :to="{name: 'birth-noncertified-image'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Informational Noncertified Birth Record - Image of Paper Record"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text class="no-decoration">-->
<!--                                Noncertified (informational only) birth record issued from the paper image. Available for births from 1900 to 2000.-->
<!--                            </b-card-text>-->
<!--                            <b-card-text class="no-decoration">-->
<!--                              <b>Price:</b> $13 (Additional Copies $6)-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                    <router-link :to="{name: 'birth-verification'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Verification of Birth Facts"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text class="no-decoration">-->
<!--                                Noncertified (informational only) document printed on plain paper verifying that a Minnesota birth record exists for a specific-->
<!--                                person. Available for births from 1900 to the present.-->
<!--                            </b-card-text>-->
<!--                            <b-card-text class="no-decoration">-->
<!--                              <b>Price:</b> $9-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <router-link :to="{name: 'birth-change-summary'}">-->
<!--                  <b-card-->
<!--                      class="order-card"-->
<!--                      border-variant="primary"-->
<!--                      header="Birth Record Changes Summary"-->
<!--                      header-class="text-left"-->
<!--                      header-bg-variant="primary"-->
<!--                      header-text-variant="white"-->
<!--                      align="left"-->
<!--                  >-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      Noncertified (informational only) document summarizing the changes made to a birth record.-->
<!--                    </b-card-text>-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      <b>Price:</b> $9-->
<!--                    </b-card-text>-->
<!--                  </b-card>-->
<!--                </router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--                <b-col>-->
<!--                    <router-link :to="{name: 'birth-noncertified-adopted'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Noncertified Original Birth Record - Adopted Person Documents"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text class="no-decoration">-->
<!--                                Noncertified (informational only) birth record issued from the original birth record before adoption and other related documents-->
<!--                                printed on plain paper. Available to adopted people age 18 or older or certain relatives, if the adopted person is deceased,-->
<!--                                for births from 1900 to the present.-->
<!--                            </b-card-text>-->
<!--                            <b-card-text class="no-decoration">-->
<!--                              <b>Price:</b> $40-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--                <b-col>-->
<!--                    <router-link :to="{name: 'birth-noncertified-original'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Noncertified Original Birth Record - Before Adoption"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text class="no-decoration">-->
<!--                                Noncertified (informational only) birth record issued from the original birth record before adoption printed on plain paper.-->
<!--                                Available to birth parents whose name appears on the original record, tribal representatives, or those with court orders, for-->
<!--                                births from 1900 to the present.-->
<!--                            </b-card-text>-->
<!--                            <b-card-text class="no-decoration">-->
<!--                              <b>Price:</b> $13 (Additional Copies $6)-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <router-link :to="{name: 'birth-homeless'}">-->
<!--                  <b-card-->
<!--                      class="order-card"-->
<!--                      border-variant="primary"-->
<!--                      header="Birth Certificate - Homeless Youth"-->
<!--                      header-class="text-left"-->
<!--                      header-bg-variant="primary"-->
<!--                      header-text-variant="white"-->
<!--                      align="left"-->
<!--                  >-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      Certified record of a birth issued on security paper. The birth certificate expires six months from the date issued. Available to homeless people who are 24 years old or younger and born in Minnesota.-->
<!--                    </b-card-text>-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      <b>Price:</b> $0-->
<!--                    </b-card-text>-->
<!--                  </b-card>-->
<!--                </router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <router-link :to="{name: 'birth-va'}">-->
<!--                  <b-card-->
<!--                      class="order-card"-->
<!--                      border-variant="primary"-->
<!--                      header="Birth Certificate - Veterans Administration"-->
<!--                      header-class="text-left"-->
<!--                      header-bg-variant="primary"-->
<!--                      header-text-variant="white"-->
<!--                      align="left"-->
<!--                  >-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      Certified record of a birth issued on security paper. Use of the certificate is limited to claims made to the United States Veterans Administration or in connection with any veteran's organization or the Department of Veterans Affairs.-->
<!--                    </b-card-text>-->
<!--                    <b-card-text class="no-decoration">-->
<!--                      <b>Price:</b> $0-->
<!--                    </b-card-text>-->
<!--                  </b-card>-->
<!--                </router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
  }),
  
  computed: {
  },

  mounted() {
  },

  methods: {
  },
  created() {
    document.title = "Select Birth Record Product - Online Storefront"
  },

}
</script>

<style>
 .green-header {
     color: #60A609;
 }
</style>
